<template>
	<div v-loading="dataLoading">
		<div class="choose-box">
			<el-form :model="formData" ref="formData" label-position="top" size="medium">
				<el-form-item label="" prop="type">
					<el-radio-group v-model="formData.type">
						<el-radio-button v-for="item in data" :key="item.id" :label="item.id">{{ item.name
                        }}</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<div class="page-filter-box">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="12" :md="8" :lg="8">
							<el-select v-model="formData.queryType" placeholder="请选择" size="small" @change="changeType">
								<el-option label="按注册时间查看乐迷" :value="0" v-if="formData.type == 1 "></el-option>
								<el-option label="按演出查看乐迷" :value="1"></el-option>
								<el-option label="按B类查看乐迷" :value="2" v-if="formData.type == 1 "></el-option>
								<el-option label="按地区查看乐迷" :value="3" v-if="formData.type == 1 "></el-option>
							</el-select>
						</el-col>
						<el-col :xs="24" :sm="12" :md="14" :lg="12" :xl="8" v-if="formData.queryType == 0 && formData.type == 1">
							<div class="clearfix">
								<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
									end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
									:default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
								</el-date-picker>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="8" v-if="formData.queryType == 1 && formData.type == 1 ">
							<el-cascader v-model="formData.queryActivityType" :options="ActivityOptions"
								:props="{ label: 'name', children: 'ActivityOptions', value: 'value', multiple: true, checkStrictly: true }"
								clearable size="small" style="width: 100%;"></el-cascader>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="8" v-if="formData.queryType == 1 && formData.type == 2 ">
							<el-cascader v-model="formData.queryActivityType" :options="ActivityOptions2"
								:props="{ label: 'name', children: 'ActivityOptions2', value: 'value', multiple: true, checkStrictly: true }"
								clearable size="small" style="width: 100%;"></el-cascader>
						</el-col>
						<el-col v-if="formData.queryType == 1 || formData.queryType == 2" :xs="24" :sm="12" :md="8"
							:lg="8">
							<el-input v-model="formData.queryValue"
								:placeholder=" formData.queryType == 1 ? '支持填写多个演出ID' : '支持填写多个B类用户的ID' "
								size="small"></el-input>
						</el-col>
						<el-col :xs="24" :sm="12" :md="14" :lg="12" :xl="8" v-if="formData.queryType == 3">
							<el-cascader v-model="formData.sellArea" :options="cityList" filterable size="small"
								style="width: 70%;" placeholder="请选择地区"
								:props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }">
							</el-cascader>
						</el-col>
					</el-row>
				</div>

				<template v-if="currentEnclosing">
					<template v-if="currentEnclosing.childList && currentEnclosing.childList.length > 0">
						<div v-for="(item, index) in formData.queryList" :key="index" class="query-box MT20">
							<el-card class="MB20">
								<div slot="header" class="query-header">
									<div class="title">查询块{{ index + 1 }}</div>
									<div class="tool-box">
										<el-button type="primary" plain size="mini"
											@click="addParams(index)">添加查询条件</el-button>
										<el-button v-if="index > 0" type="danger" plain size="mini"
											@click="removeQuery(index)">删除查询块</el-button>
									</div>
								</div>
								<table width="100%" border="0" cellspacing="0" cellpadding="0">
									<tr>
										<td v-if="item.query.length > 1" class="isOr">
											<el-form-item :prop="`queryList[${index}].isOr`" label="">
												<el-select v-model="item.isOr" style="width: 120px;" size="medium">
													<el-option :value="0" label="并且"></el-option>
													<el-option :value="1" label="或者" v-if="formData.type == 1"></el-option>
												</el-select>
											</el-form-item>
										</td>
										<td class="params">
											<div v-for="(q, i) in item.query" :key="i" class="query-group">
												<div class="params-group">
													<el-form-item :prop="`queryList[${index}].query[${i}].labelId`"
														label="">
														<el-cascader v-model="q.labelId"
															:options="currentEnclosing.childList"
															:props="{ emitPath: false, value: 'id', label: 'name', children: 'childList' }"
															placeholder="一级标签/二级标签/标签名称" filterable
															:ref="`cascader_${index}_${i}`"
															@change="labelChange(index, i)" style="width: 100%;">
														</el-cascader>
													</el-form-item>
													<el-form-item :prop="`queryList[${index}].query[${i}].type`"
														label="">
														<el-select v-model="q.type" :disabled="!q.label ? true : false"
															@change="typeChange(index, i)">
															<el-option :value="0" label="等于" v-if="formData.type == 1"></el-option>
															<el-option :value="1" label="不等于" v-if="formData.type == 1"></el-option>
															<el-option :value="2" label="包含"></el-option>
															<el-option :value="3" label="不包含" v-if="formData.type == 1"></el-option>
															<template
																v-if="q.label && !q.label.labelValues && q.label.id != 25 && q.label.id != 26 && q.label.id != 27 && q.label.id != 28 && q.label.id != -3">
																<el-option :value="4" label="大于"></el-option>
																<el-option :value="5" label="大于等于"></el-option>
																<el-option :value="6" label="小于"></el-option>
																<el-option :value="7" label="小于等于"></el-option>
															</template>
														</el-select>
													</el-form-item>

													<el-form-item :prop="`queryList[${index}].query[${i}].value`"
														label="" :key="q.type">
														<el-select v-model="q.value"
															v-if="q.label && q.label.labelValues"
															:multiple="q.type > 1 ? true : false" placeholder="选择标签值"
															:disabled="!q.label ? true : false">
															<el-option v-for="v in q.label.labelValues" :key="v.id"
																:label="v.actualMeaning" :value="v.id">
															</el-option>
														</el-select>
														<el-select
															v-else-if="q.label && (q.label.id == 25 || q.label.id == 27 )"
															v-model="q.value" :multiple="q.type > 1 ? true : false"
															placeholder="选择省份" filterable>
															<el-option v-for="(p, x) in province" :key="x" :value="p.id"
																:label="p.name"></el-option>
														</el-select>
														<el-cascader
															v-else-if="q.label && (q.label.id == 26 || q.label.id == 28 || q.label.id == 185 || q.label.id == -2 )"
															v-model="q.value" :options="cityList" filterable
															collapse-tags
															:props="{ label: 'name', children: 'cityList', value: 'code', emitPath: false, multiple: q.type > 1 ? true : false }"
															style="width:100%" ref="cityCascader">
														</el-cascader>														
														<el-date-picker
															v-else-if="q.label && (q.label.id == -3 )"
														    v-model="q.value"
														    type="datetimerange"
														    start-placeholder="开始日期"
														    end-placeholder="结束日期"
														    value-format="yyyy-MM-dd HH:mm:ss"
														    unlink-panels
														    size="medium">
														</el-date-picker>
														<el-input v-else v-model="q.value" placeholder="输入标签值，多个标签用逗号分隔"
															:disabled="!q.label ? true : false"></el-input>
													</el-form-item>
												</div>
												<div class="handle">
													<el-button v-if="i > 0" size="medium"
														@click="removeParams(index, i)">删除</el-button>
												</div>
											</div>
										</td>
									</tr>
								</table>
							</el-card>
							<el-divider v-if="index < formData.queryList.length - 1">并且</el-divider>
						</div>
						<div><el-button plain @click="addQuery" icon="el-icon-plus" class="add-query-btn"
								v-if="formData.type == 1">添加查询块</el-button></div>
						<div class="MT20" v-if="formData.type == 1">
							<el-card header="选择要展示的图表">
								<el-checkbox-group v-model="formData.diagrams" size="medium">
									<div class="diagrams-group MB20" v-for="(item,index) in chartStyleList"
										:key="index">
										<div class="diagrams-title ">{{item.label}}:</div>
										<el-checkbox v-for="(c,i) in item.children" :key="i" :label="c.value"
											class="MT10">{{c.label}}</el-checkbox>
									</div>
								</el-checkbox-group>
							</el-card>
						</div>
						<div class="btn-box">
							<div class="btns MT30">
								<el-button type="primary" icon="el-icon-search" @click="query(formData.type,1)"
									:loading="btnLoading">查询</el-button>
								<el-button type="primary" icon="el-icon-download" @click="query(formData.type,2)"
									:loading="btnLoading">导出</el-button>
								<el-button icon="el-icon-refresh-left" @click="clearQuery">重置</el-button>
							</div>
						</div>
					</template>
					<el-card v-else>
						暂无可查询条件
					</el-card>
				</template>
			</el-form>
		</div>
		<template v-if="formData.type == 1">
			<el-card class="box-card MT20"
				v-if="chartdata && chartdata.cityDiagrams && chartdata.cityDiagrams.length > 0 || chartdata && chartdata.provinceDiagrams && chartdata.provinceDiagrams.length > 0  || chartdata && chartdata.provinceLastDiagrams && chartdata.provinceLastDiagrams.length > 0   || chartdata && chartdata.cityLastDiagrams && chartdata.cityLastDiagrams.length > 0 ">
				<div slot="header" class="clearfix">
					<span>
						<span class="el-icon-data-line"></span> 地区
					</span>
				</div>
				<div>
					<el-button size="small" @click="areaData(1)" :class="current == 1 ? 'current' : ''">出生地</el-button>
					<el-button size="small" @click="areaData(2)" :class="current == 2 ? 'current' : ''">登录地</el-button>
				</div>
				<div id="chartMap" class="chinamap" ref="chartMap"></div>
			</el-card>
			<el-row :gutter="20" class="cardBox">
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.ageDiagrams && chartdata.ageDiagrams.length > 0">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 年龄段
						</span>
					</div>
					<div id="ageChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.sexDiagrams && chartdata.sexDiagrams.length > 0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 性别
						</span>
					</div>
					<div id="sexChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.horoscopeDiagrams && chartdata.horoscopeDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 星座
						</span>
					</div>
					<div id="xingzuoChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.chineseZodiacDiagrams && chartdata.chineseZodiacDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 生肖
						</span>
					</div>
					<div id="shengxiaoChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.certMonthDiagrams && chartdata.certMonthDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 出生月份
						</span>
					</div>
					<div id="bornMonthChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.deviceDiagrams && chartdata.deviceDiagrams.length > 0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 设备
						</span>
					</div>
					<div id="devicesChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.activeTimeDiagrams && chartdata.activeTimeDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 活跃时间段
						</span>
					</div>
					<div id="timeChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.preMonthActiveTimeDiagrams && chartdata.preMonthActiveTimeDiagrams.length >0">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 上月活跃度
						</span>
					</div>
					<div id="lastMonthChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.styleDiagrams && chartdata.styleDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 购买演出风格偏好人数占比
						</span>
					</div>
					<div id="buyActivityChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.activityTypeDiagrams && chartdata.activityTypeDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 购买活动类型偏好人数占比
						</span>
					</div>
					<div id="buyOthersChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.useCouponDiagrams && chartdata.useCouponDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 优惠券使用意愿
						</span>
					</div>
					<div id="couponChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.usePayPlatformDiagrams && chartdata.usePayPlatformDiagrams.length >0">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 支付渠道偏好
						</span>
					</div>
					<div id="payChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.silenceDiagrams && chartdata.silenceDiagrams.length>0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 是否沉默
						</span>
					</div>
					<div id="silenceChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.rfmDiagrams && chartdata.rfmDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> RFM
						</span>
					</div>
					<div id="RFMChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.userLevelDiagrams && chartdata.userLevelDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 黄牛级别
						</span>
					</div>
					<div id="scalperChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.videoTimeDiagrams && chartdata.videoTimeDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 视频观看时段分布
						</span>
					</div>
					<div id="videoChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.videoDeviceDiagrams && chartdata.videoDeviceDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 视频观看设备
						</span>
					</div>
					<div id="videodevicesChart"></div>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="8"
				v-if="chartdata && chartdata.durationDiagrams && chartdata.durationDiagrams.length >0 ">
				<el-card class="box-card MT20">
					<div slot="header" class="clearfix">
						<span>
							<span class="el-icon-data-line"></span> 单次播放视频时长分布
						</span>
					</div>
					<div id="videotimeChart"></div>
				</el-card>
			</el-col>
		</el-row>
		</template>
		<template v-else>
			<el-card shadow="never" class="statistics-box"  v-if="eventsActivityDiagrams && eventsActivityDiagrams.length > 0">
			    <el-row :gutter="20">
			        <el-col :xs="12" :sm="8" :md="6" :lg="4"  v-for="(item, index) in eventsActivityDiagrams" :key="index"><p class="num">{{item.num}}</p><p class="color-info">{{item.name}}</p></el-col>
			        
			    </el-row>
			</el-card>			
		</template>
	</div>
</template>

<script>
	import dayjs from 'dayjs';
	import {
		fetchProvince,
		fetchAllCity
	} from '@/assets/js/commonApi'
	import {
		Chart
	} from '@antv/g2';
	import {
		Choropleth
	} from '@antv/l7plot';




	const _defaultQuery = {
		labelId: "",
		type: 2,
		value: "",
		label: null
	}
	const _defaultQueryGroup = {
		isOr: 0,
		query: [{
			..._defaultQuery
		}]
	}
	export default {
		// name: 'EChartsComponent',
		data() {
			return {
				value: {
					type: Number,
					default: 0
				},

				data: null,
				chartdata: null,
				dataLoading: false,
				formData: {
					type: "",
					queryList: [],
					queryType: 1,
					queryValue: '',
					sellArea: [],
					diagrams: ['0', '1', '2', '3', '4', '6', '15'],
					queryActivityType: []
				},
				currentEnclosing: null,
				queryData: null,
				btnLoading: false,
				notify: null,
				province: [],
				cityList: [],
				datetimerange: [],
				ActivityOptions: [{
						value: '0',
						name: '演出购票乐迷',
					},
					{
						value: '4',
						name: '演出观演乐迷',
					},
					{
						value: '1',
						name: '演出收藏乐迷',
					},
					{
						value: '2',
						name: '开票登记乐迷',
					},
					{
						value: '3',
						name: '缺票登记乐迷',
					},
				],
				ActivityOptions2: [{
						value: '8',
						name: '关注演出艺人乐迷',
					},
					{
						value: '5',
						name: '购买艺人历史演出乐迷',
					},
					{
						value: '9',
						name: '购买艺人历史专场演出',
					},					
					{
						value: '6',
						name: '浏览演出详情乐迷',
					},
					{
						value: '1',
						name: '收藏演出乐迷',
					},
					{
						value: '7',
						name: '90天内购买相似演出乐迷',
					},
					{
						value: '10',
						name: '缺票登记乐迷',
					}
				],
				chartStyleList: [{
					label: '基础属性',
					children: [{
						label: '年龄段',
						value: '1'
					}, {
						label: '身份证性别',
						value: '2'
					}, {
						label: '星座',
						value: '3'
					}, {
						label: '生肖',
						value: '4'
					}, {
						label: '出生月份',
						value: '5'
					}]
				}, {
					label: '地理位置',
					children: [{
						label: '地区',
						value: '0'
					}]
				}, {
					label: '兴趣偏好',
					children: [{
						label: '购买演出风格偏好人数占比',
						value: '6'
					}, {
						label: '购买活动类型偏好人数占比',
						value: '10'
					}]
				}, {
					label: '行为习惯',
					children: [{
						label: '活跃时间段',
						value: '7'
					}, {
						label: '上月活跃度',
						value: '8'
					}, {
						label: '设备',
						value: '9'
					}, {
						label: '优惠券使用意愿',
						value: '11'
					}, {
						label: '支付渠道偏好',
						value: '12'
					}, {
						label: '是否沉默',
						value: '13'
					}]
				}, {
					label: '资信能力',
					children: [{
						label: 'RFM',
						value: '14'
					}, {
						label: '黄牛级别',
						value: '15'
					}]
				}, {
					label: '视频统计',
					children: [{
						label: '视频观看时段分布',
						value: '16'
					}, {
						label: '视频观看设备',
						value: '17'
					}, {
						label: '单次播放视频时长分布',
						value: '18'
					}]
				}],
				// chartStyleList: [{
				// 	label: '地区',
				// 	value: '0'
				// }, {
				// 	label: '年龄段',
				// 	value: '1'
				// }, {
				// 	label: '身份证性别',
				// 	value: '2'
				// }, {
				// 	label: '星座',
				// 	value: '3'
				// }, {
				// 	label: '生肖',
				// 	value: '4'
				// }, {
				// 	label: '出生月份',
				// 	value: '5'
				// }, {
				// 	label: '购买演出风格偏好人数占比',
				// 	value: '6'
				// }, {
				// 	label: '活跃时间段',
				// 	value: '7'
				// }, {
				// 	label: '上月活跃度',
				// 	value: '8'
				// }, {
				// 	label: '设备',
				// 	value: '9'
				// }, {
				// 	label: '购买活动类型偏好人数占比',
				// 	value: '10'
				// }, {
				// 	label: '优惠券使用意愿',
				// 	value: '11'
				// }, {
				// 	label: '支付渠道偏好',
				// 	value: '12'
				// }, {
				// 	label: '是否沉默',
				// 	value: '13'
				// }, {
				// 	label: 'RFM',
				// 	value: '14'
				// }, {
				// 	label: '黄牛级别',
				// 	value: '15'
				// }, {
				// 	label: '视频观看时段分布',
				// 	value: '16'
				// }, {
				// 	label: '视频观看设备',
				// 	value: '17'
				// }, {
				// 	label: '单次播放视频时长分布',
				// 	value: '18'
				// }],
				chart1: null,
				chart2: null,
				chart3: null,
				chart4: null,
				chart5: null,
				chart6: null,
				chart7: null,
				chart8: null,
				chart9: null,
				chart10: null,
				chart11: null,
				chart12: null,
				chart13: null,
				chart14: null,
				chart15: null,
				chart16: null,
				chart17: null,
				chart18: null,
				chinaMap: null,
				mapData: [],
				mapOption: [], //地图属性,
				current: 1,
				eventsActivityDiagrams:[]

			}
		},
		watch: {
			'formData.type': {
				handler(val) {
					this.currentEnclosing = this.data.find(item => item.id == val)
					this.reset()
				},
				deep: true
			}
		},
		created() {
			const date = new Date();
			const month = date.getMonth();
			const day = date.getDate();
			const start = new Date();
			const end = new Date();
			start.setMonth(month - 3, day);
			start.setHours(0, 0, 0);
			end.setHours(23, 59, 59);
			this.datetimerange = [dayjs(start).format('YYYY-MM-DD HH:mm:ss'), dayjs(end).format('YYYY-MM-DD HH:mm:ss')]


		},
		mounted() {
			this.addQuery()
			this.getData()
			this.getProvince()
			this.getCityList()
			this.getMapinfo()
			this.drawAllCharts()
		},
		methods: {
			getMapinfo() {
				this.$request({
						url: "/common/getMapInfo",
						method: "POST",
						data: {}
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.mapOption = JSON.parse(result);
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
			},
			getData() {
				this.dataLoading = true
				this.$request({
						url: "/label/chooseBox",
						method: "POST",
						data: {},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.formData.type = this.data.length > 0 ? this.data[0].id : ""

						} else {
							this.data = null;
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			//获取所有省份
			async getProvince() {
				const res = await fetchProvince({}).catch(() => {});
				const {
					state,
					result
				} = res.data;
				if (state == 1) {
					this.province = result;
				}
			},
			//获取所有城市
			async getCityList() {
				const res = await fetchAllCity({}).catch(() => {});
				const {
					state,
					result
				} = res.data;
				if (state == 1) {
					this.cityList = result;
				}
			},
			//添加查询块
			addQuery() {
				this.formData.queryList.push({
					..._defaultQueryGroup,
					query: [{
						..._defaultQuery
					}]
				})
			},
			// 删除查询块
			removeQuery(index) {
				this.formData.queryList.splice(index, 1)
			},
			// 添加查询条件
			addParams(index) {
				this.formData.queryList[index].query.push({
					..._defaultQuery
				})
			},
			//删除查询条件
			removeParams(index, i) {
				this.formData.queryList[index].query.splice(i, 1)
			},
			//选择标签
			labelChange(index, i) {
				this.$nextTick(() => {
					this.formData.queryList[index].query[i].label = (this.$refs[`cascader_${index}_${i}`][0])
						.getCheckedNodes()[0].data
					this.formData.queryList[index].query[i].type = 2;
					this.formData.queryList[index].query[i].value = "";
				})
			},
			//选择类型
			typeChange(index, i) {
				// this.$nextTick(() => {
				if (this.formData.queryList[index].query[i].type > 1 && this.formData.queryList[index].query[i].label &&
					this.formData.queryList[index].query[i].label.labelValues) {
					this.formData.queryList[index].query[i].value = [];
				} else {
					this.formData.queryList[index].query[i].value = "";
				}
				// this.$forceUpdate()
				// })
			},
			drawAllCharts() {
				if (this.chartdata && this.mapData && this.mapData.length > 0) {
					this.$nextTick(() => {
						this.getMap()
					})
				}
				if (this.chartdata && this.chartdata.ageDiagrams && this.chartdata.ageDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart()
					})
				}
				if (this.chartdata && this.chartdata.sexDiagrams && this.chartdata.sexDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart1()
					})
				}
				if (this.chartdata && this.chartdata.horoscopeDiagrams && this.chartdata.horoscopeDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart3()
					})
				}
				if (this.chartdata && this.chartdata.chineseZodiacDiagrams && this.chartdata.chineseZodiacDiagrams.length >
					0) {
					this.$nextTick(() => {
						this.drawChart4()
					})
				}
				if (this.chartdata && this.chartdata.certMonthDiagrams && this.chartdata.certMonthDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart5()
					})
				}
				if (this.chartdata && this.chartdata.deviceDiagrams && this.chartdata.deviceDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart6()
					})
				}
				if (this.chartdata && this.chartdata.activeTimeDiagrams && this.chartdata.activeTimeDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart7()
					})
				}
				if (this.chartdata && this.chartdata.preMonthActiveTimeDiagrams && this.chartdata
					.preMonthActiveTimeDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart8()
					})
				}

				if (this.chartdata && this.chartdata.styleDiagrams && this.chartdata.styleDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart9()
					})
				}
				if (this.chartdata && this.chartdata.activityTypeDiagrams && this.chartdata.activityTypeDiagrams.length >
					0) {
					this.$nextTick(() => {
						this.drawChart10()
					})
				}

				if (this.chartdata && this.chartdata.useCouponDiagrams && this.chartdata.useCouponDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart11()
					})
				}
				if (this.chartdata && this.chartdata.usePayPlatformDiagrams && this.chartdata.usePayPlatformDiagrams
					.length > 0) {
					this.$nextTick(() => {
						this.drawChart12()
					})
				}
				if (this.chartdata && this.chartdata.silenceDiagrams && this.chartdata.silenceDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart13()
					})
				}
				if (this.chartdata && this.chartdata.rfmDiagrams && this.chartdata.rfmDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart14()
					})
				}
				if (this.chartdata && this.chartdata.userLevelDiagrams && this.chartdata.userLevelDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart15()
					})
				}
				if (this.chartdata && this.chartdata.videoTimeDiagrams && this.chartdata.videoTimeDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart16()
					})
				}
				if (this.chartdata && this.chartdata.videoDeviceDiagrams && this.chartdata.videoDeviceDiagrams.length >
					0) {
					this.$nextTick(() => {
						this.drawChart17()
					})
				}
				if (this.chartdata && this.chartdata.durationDiagrams && this.chartdata.durationDiagrams.length > 0) {
					this.$nextTick(() => {
						this.drawChart18()
					})
				}
			},
			//查询  action 1是查询，2是导出  type 1是乐迷 2是活动
			query(type,action) {
				console.log(type)
				console.log(action)
				this.chartdata = null;

				this.formData.provinceCode = [];
				this.formData.cityCode = [];

				this.formData.sellArea.map(item => {
					if (!this.formData.provinceCode.find(v => v == item[0]) && !item[1]) {
						this.formData.provinceCode.push(item[0]);
					}
					item[1] && this.formData.cityCode.push(item[1]);
				})

				if (this.formData.queryType == 0 && this.datetimerange == '' && this.formData.type == 1 ) {
					return this.$message.error("时间不能为空！");
				}

				if (this.formData.queryType == 1 && this.formData.queryActivityType == '') {
					return this.$message.error("请选择乐迷的类型！");
				}
				if (this.formData.queryType == 3 && (this.formData.provinceCode == '' && this.formData.cityCode == '')) {
					return this.$message.error("地区不能为空！");
				}
				if ((this.formData.queryType == 1 || this.formData.queryType == 2) && this.formData.queryValue == '' ) {
					return this.$message.error("ID不能为空！");
				}
				var arr = []
				arr = this.formData.queryActivityType.flat()
				var activityTypeArr = arr.map(item => Number(item));

				if (this.datetimerange != '' && this.formData.queryType === 0 && this.formData.type == 1 ) {
					var k1 = new Date(this.datetimerange[1]).getTime() - new Date(this.datetimerange[0]).getTime();
					var k2 = parseInt(k1 / (1000 * 60 * 60 * 24));

					if (k2 > 730) {
						this.$message.error('目前最大支持查询的时间跨度为730天')
						return;
					}
				}

				if (this.formData.diagrams && this.formData.diagrams.length == 0) {
					this.$message.error('请至少勾选1项显示的图表')
					return;
				}

				this.$refs["formData"].validate((valid) => {
					if (valid) {
						let _queryData = {
							type: this.formData.type,
							queryList: JSON.parse(JSON.stringify(this.formData.queryList)),
							queryType: this.formData.queryType,
							queryValue: this.formData.queryValue,
							diagrams: this.formData.diagrams.toString(),
							startTime: this.formData.type == 1 ? this.datetimerange[0] || '' : '',
							endTime:  this.formData.type == 1 ? this.datetimerange[1] || '' : '',
							provinceCode: this.formData.provinceCode.toString(),
							cityCode: this.formData.cityCode.toString(),
							queryActivityType: activityTypeArr,

						}

						_queryData.queryList.forEach(item => {
							item.query.forEach(query => {
								if (query.value == '') {
									_queryData.queryList = []
								} else {
									delete query.label;
									query.value = query.value.toString();
									query.value = query.value.replaceAll("，", ",");
								}

							})
						})

						this.queryData = _queryData;
						console.log(this.queryData)

						this.dataLoading = true; //action 1是查询，2是导出  type 1是乐迷 2是活动
						//var _url = type == 1 ? '/label/diagrams' : '/label/events/diagrams'
						var _url = ''
						if( type == 1 && ( action == 1 || action == 2 )){
							_url = '/label/diagrams'
						}
						if( type == 2 && action == 1 ){
							_url = '/label/events/diagrams'
						}
						if( type == 2 && action == 2 ){
							_url = '/label/events/export'
						}
						this.$request({
								url:_url,
								data: {
									...this.queryData
								},
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg,
									result
								} = res.data;
								
								
								if (state == 1 && result ) {
									this.dataLoading = false

									this.chartdata = result
									//地图 cityDiagrams 市出生地 provinceDiagrams 省出生地   provinceLastDiagrams 省最近登录  cityLastDiagrams  市最近登录
									
									if( type == 2 && action == 2 ){
										this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
										    confirmButtonText: '立即查看',
										    cancelButtonText: '稍后再看',
										    type: 'success',
										    center: true,
										    closeOnClickModal: false
										}).then(() => {
										    this.$router.push({path:'/workbench/downloadList'})
										}).catch(() => {
											this.dataLoading = false
										})
									}
									if( type == 2 && action == 1 ){
										this.eventsActivityDiagrams = result.eventsActivityDiagrams
									}
									
									if (this.mapOption && this.mapOption.length > 0 && result
										.provinceDiagrams && result.provinceDiagrams.length > 0) {
										let _provinceDiagrams = result.provinceDiagrams;
										this.mapOption.forEach(v => {
											_provinceDiagrams.forEach(item => {
												if (v.name.includes(item.name)) {
													item.name = v.name
												}
											})
										})
										let _cityDiagrams = result.cityDiagrams;
										this.mapOption.forEach(v => {
											_cityDiagrams.forEach(item => {
												if (v.name.includes(item.name)) {
													item.name = v.name
												}
											})
										})
										this.mapData = _provinceDiagrams.concat(_cityDiagrams);
									}									
									if (this.chartdata) {
										this.current = 1
										this.drawAllCharts()
										if (action == 2 && type == 1 ) {
											this.$confirm(
												'<div class="color-danger">共圈选到' + result.total + '个对象</div>\
											<div>暂时最多仅能导出<span class="color-danger">100W</span>条数据</div>',
												'圈选结果', {
													dangerouslyUseHTMLString: true,
													center: true,
													closeOnClickModal: false,
													dangerouslyUseHTMLString: true,
													confirmButtonText: result.total > 0 && result.total <
														1000000 ? '确认导出' : '确定',

													cancelButtonText: '取消',
												}
											).then(() => {
												if (result.total > 0 && result.total < 1000000) {
													this.export();
												}
											}).catch(() => {
												this.dataLoading = false;
											});
										}

									}
									
									
							
								} else {
									this.$message.error(msg || "操作失败,请重试");
									this.dataLoading = false
								}
							})

					} else {
						return false;
					}
				})
			},
			areaData(type) {
				if (type == 1) {
					this.current = 1
					// this.mapData = this.chartdata.provinceDiagrams.concat(this.chartdata.cityDiagrams);

					if (this.mapOption && this.mapOption.length > 0 && this.chartdata.provinceDiagrams && this.chartdata
						.provinceDiagrams.length > 0) {
						let _provinceDiagrams = this.chartdata.provinceDiagrams;
						this.mapOption.forEach(v => {
							_provinceDiagrams.forEach(item => {
								if (v.name.includes(item.name)) {
									item.name = v.name
								}
							})
						})
						let _cityDiagrams = this.chartdata.cityDiagrams;
						this.mapOption.forEach(v => {
							_cityDiagrams.forEach(item => {
								if (v.name.includes(item.name)) {
									item.name = v.name
								}
							})
						})

						this.mapData = _provinceDiagrams.concat(_cityDiagrams);
					}
					this.$nextTick(() => {
						this.getMap()
					})
				} else {
					this.current = 2
					// this.mapData = this.chartdata.provinceLastDiagrams.concat(this.chartdata.cityLastDiagrams);
					if (this.mapOption && this.mapOption.length > 0 && this.chartdata.provinceLastDiagrams && this
						.chartdata.provinceLastDiagrams.length > 0) {
						let _provinceLastDiagrams = this.chartdata.provinceLastDiagrams;
						this.mapOption.forEach(v => {
							_provinceLastDiagrams.forEach(item => {
								if (v.name.includes(item.name)) {
									item.name = v.name
								}
							})
						})
						let _cityLastDiagrams = this.chartdata.cityLastDiagrams;
						this.mapOption.forEach(v => {
							_cityLastDiagrams.forEach(item => {
								if (v.name.includes(item.name)) {
									item.name = v.name
								}
							})
						})

						this.mapData = _provinceLastDiagrams.concat(_cityLastDiagrams);
					}
					this.$nextTick(() => {
						this.getMap()
					})
				}

			},
			//地区地图
			getMap() {
				console.log(this.mapData)
				//地图 cityDiagrams 市出生地 provinceDiagrams 省出生地   provinceLastDiagrams 省最近登录  cityLastDiagrams  市最近登录
				if (this.chartdata && this.mapData && this.mapData.length > 0) {

					if (this.chinaMap) this.chinaMap.destroy();
					this.chinaMap = new Choropleth('chartMap', {
						map: {
							type: 'amap',
							// style: 'blank',
							center: [120.19382669582967, 30.258134],
							zoom: 3,
							pitch: 0,
						},
						source: {
							data: this.mapData ? this.mapData : [],
							joinBy: {
								sourceField: 'name',
								geoField: 'name',
							},
						},
						viewLevel: {
							level: 'country',
							adcode: 100000,
						},
						autoFit: true,
						theme: 'dark',
						color: {
							field: 'num',
							value: ['#B8E1FF', '#7DAAFF', '#3D76DD', '#0047A5', '#001D70'],
							scale: {
								type: 'quantile'
							},
						},
						style: {
							opacity: 1,
							stroke: '#ccc',
							lineWidth: 0.6,
							lineOpacity: 1,
						},
						label: {
							visible: true,
							field: 'name',
							style: {
								fill: '#000',
								opacity: 0.8,
								fontSize: 10,
								stroke: '#fff',
								strokeWidth: 1.5,
								textAllowOverlap: false,
								padding: [5, 5],
							},
						},
						state: {
							active: {
								stroke: 'yellow',
								lineWidth: 1,
								lineOpacity: 0.8
							},
						},
						tooltip: {
							items: [{
									field: "name",
									alias: "名称"
								},
								{
									field: "num",
									alias: "数值"
								},
								{
									field: "ratio",
									alias: "比例"
								},
							]
						},
						chinaBorder: {
							national: {
								color: 'blue',
								width: 0.5
							},
						},
						drill: {
							steps: ['province'],
							onDown: (from, to, callback) => {
								const {
									level,
									adcode,
									granularity
								} = to
								callback({
									source: {
										data: this.mapData || [],
										joinBy: {
											sourceField: 'name',
											geoField: 'name',
										}
									},
									color: {
										field: 'num',
										value: ['#B8E1FF', '#7DAAFF', '#3D76DD', '#0047A5', '#001D70'],
										scale: {
											type: 'quantile'
										},
									},
									state: {
										active: {
											stroke: 'yellow',
											lineWidth: 1,
											lineOpacity: 0.8,
										}
									},
									tooltip: {
										items: [{
												field: "name",
												alias: "名称"
											},
											{
												field: "num",
												alias: "数值"
											},
											// {
											// 	field: "ratio",
											// 	alias: "比例"
											// },
										]
									},
									granularity: 'city'
								})

							},
							onUp: (from, to, callback) => {
								callback()
							},
						},
						zoom: {
							position: 'topleft',
						},


					});
					this.chinaMap.render();
				}

			},

			//年龄
			drawChart() {
				if (this.chart1) this.chart1.destroy();

				let _data = [];
				_data = [...this.chartdata.ageDiagrams];

				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart1 = new Chart({
					container: 'ageChart',
					autoFit: true,
					height: 400,
				});
				this.chart1.data(_data);
				this.chart1.interaction('active-region');

				this.chart1.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart1.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart1.render();
			},
			//性别
			drawChart1() {
				if (this.chart2) this.chart2.destroy();

				let _data = [];
				_data = [...this.chartdata.sexDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart2 = new Chart({
					container: 'sexChart',
					autoFit: true,
					height: 400,

				});
				this.chart2.coordinate('theta', {
					radius: 0.6,
				});

				this.chart2.data(_data);
				this.chart2.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart2.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart2.legend('name', {
					position: 'top',
				});
				this.chart2
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});


				this.chart2.render();
			},
			//星座
			drawChart3() {
				if (this.chart3) this.chart3.destroy();
				let _data = this.chartdata.horoscopeDiagrams
				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart3 = new Chart({
					container: 'xingzuoChart',
					autoFit: true,
					height: 400,
				});
				this.chart3.data(_data);
				this.chart3.interaction('active-region');

				this.chart3.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart3.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart3.render();
			},
			//生肖
			drawChart4() {
				if (this.chart4) this.chart4.destroy();
				let _data = this.chartdata.chineseZodiacDiagrams
				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart4 = new Chart({
					container: 'shengxiaoChart',
					autoFit: true,
					height: 400,
				});
				this.chart4.data(_data);
				this.chart4.interaction('active-region');

				this.chart4.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart4.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart4.render();
			},
			//出生月份
			drawChart5() {
				if (this.chart5) this.chart5.destroy();
				let _data = this.chartdata.certMonthDiagrams
				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart5 = new Chart({
					container: 'bornMonthChart',
					autoFit: true,
					height: 400,
				});
				this.chart5.data(_data);
				this.chart5.interaction('active-region');

				this.chart5.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart5.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart5.render();
			},
			//设备
			drawChart6() {
				if (this.chart6) this.chart6.destroy();

				let _data = [];
				_data = [...this.chartdata.deviceDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart6 = new Chart({
					container: 'devicesChart',
					autoFit: true,
					height: 400,
				});
				this.chart6.coordinate('theta', {
					radius: 0.6,
				});

				this.chart6.data(_data);
				this.chart6.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart6.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart6.legend('name', {
					position: 'top',
				});
				this.chart6
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（总数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart6.render();
			},
			//活跃时间段
			drawChart7() {
				//timeChart
				if (this.chart7) this.chart7.destroy();

				this.chart7 = new Chart({
					container: 'timeChart',
					autoFit: true,
					height: 400,
					syncViewPadding: true,
				});

				let _data = [];
				_data = [...this.chartdata.activeTimeDiagrams];
				this.chart7.data(_data);


				this.chart7.scale('ratio', { // 度量
					min: 0 // Y轴显示的最小值
				});
				this.chart7.scale('name', { // 度量
					range: [0, 1] // 数值范围区间
				});
				this.chart7.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name} </span>
			       {num} {ratio}
			        </div>
			        `,
				});
				this.chart7.line().position("name*ratio*num").tooltip("name*num*ratio", function(name, ratio, num) {
					return {
						name,
						ratio,
						num
					};
				});

				this.chart7.render();
			},
			//上月活跃度
			drawChart8() {
				if (this.chart8) this.chart8.destroy();

				let _data = [];
				_data = [...this.chartdata.preMonthActiveTimeDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart8 = new Chart({
					container: 'lastMonthChart',
					autoFit: true,
					height: 400,
				});
				this.chart8.coordinate('theta', {
					radius: 0.6,
				});

				this.chart8.data(_data);
				this.chart8.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart8.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart8.legend('name', {
					position: 'top',
				});
				this.chart8
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + ' ：' +  obj.num + ' 占比：' + obj.ratio ;
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});


				this.chart8.render();
			},
			//购买演出风格偏好人数占比
			drawChart9() {
				if (this.chart9) this.chart9.destroy();
				let _data = [];
				_data = [...this.chartdata.styleDiagrams];

				this.chart9 = new Chart({
					container: 'buyActivityChart',
					autoFit: true,
					height: 400
				});
				this.chart9.data(_data)
				this.chart9.coordinate().transpose();

				this.chart9.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name} - </span>
			       {num} - {ratio}
			        </div>
			        `,
				});
				this.chart9.interval().position("name*num*ratio").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});

				this.chart9.render();

			},
			//购买活动类型偏好人数占比
			drawChart10() {
				if (this.chart10) this.chart10.destroy();
				let _data = [];
				_data = [...this.chartdata.activityTypeDiagrams];

				this.chart10 = new Chart({
					container: 'buyOthersChart',
					autoFit: true,
					height: 400
				});
				this.chart10.coordinate().transpose();
				this.chart10.data(_data)
				this.chart10.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name} - </span>
			       {num} s- {ratio}
			        </div>
			        `,
				});
				this.chart10.interval().position("name*num*ratio").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart10.render();
			},
			//优惠券使用意愿
			drawChart11() {
				if (this.chart11) this.chart11.destroy();

				let _data = [];
				_data = [...this.chartdata.useCouponDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart11 = new Chart({
					container: 'couponChart',
					autoFit: true,
					height: 400,
				});
				this.chart11.coordinate('theta', {
					radius: 0.6,
				});

				this.chart11.data(_data);
				this.chart11.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart11.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart11.legend('name', {
					position: 'top',
				});
				this.chart11
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart11.render();
			},
			//支付渠道偏好
			drawChart12() {
				if (this.chart12) this.chart12.destroy();

				let _data = [];
				_data = [...this.chartdata.usePayPlatformDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart12 = new Chart({
					container: 'payChart',
					autoFit: true,
					height: 400,
				});
				this.chart12.coordinate('theta', {
					radius: 0.6,
				});

				this.chart12.data(_data);
				this.chart12.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart12.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart12.legend('name', {
					position: 'top',
				});
				this.chart12
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart12.render();
			},
			//是否沉默
			drawChart13() {
				if (this.chart13) this.chart13.destroy();

				let _data = [];
				_data = [...this.chartdata.silenceDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart13 = new Chart({
					container: 'silenceChart',
					autoFit: true,
					height: 400,
				});
				this.chart13.coordinate('theta', {
					radius: 0.6,
				});

				this.chart13.data(_data);
				this.chart13.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart13.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart13.legend('name', {
					position: 'top',
				});
				this.chart13
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart13.render();
			},
			//RFM
			drawChart14() {
				if (this.chart14) this.chart14.destroy();
				let _data = this.chartdata.rfmDiagrams
				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart14 = new Chart({
					container: 'RFMChart',
					autoFit: true,
					height: 400,
				});
				this.chart14.data(_data);
				this.chart14.interaction('active-region');

				this.chart14.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart14.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart14.render();
			},
			//黄牛级别
			drawChart15() {
				if (this.chart15) this.chart15.destroy();
				let _data = [];
				_data = [...this.chartdata.userLevelDiagrams];

				this.chart15 = new Chart({
					container: 'scalperChart',
					autoFit: true,
					height: 400
				});

				this.chart15.data(_data)
				this.chart15.coordinate().transpose();

				this.chart15.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name} - </span>
			       {num} - {ratio}
			        </div>
			        `,
				});
				this.chart15.interval().position("name*num*ratio").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart15.render();
			},
			//视频观看时段分布
			drawChart16() {
				if (this.chart16) this.chart16.destroy();
				let _data = this.chartdata.videoTimeDiagrams
				_data.map(v => {
					v.num = parseFloat(v.num)
				})

				this.chart16 = new Chart({
					container: 'videoChart',
					autoFit: true,
					height: 400,
				});
				this.chart16.data(_data);
				this.chart16.interaction('active-region');

				this.chart16.tooltip({
					showTitle: false, //不显示标题
					showMarkers: false, //不显示贴敷上去的小点
					position: "right", //显示位置			       
					itemTpl: `<div  style="margin-bottom: 10px;">
			        <span style="background-color:{color};" class="g2-tooltip-marker"></span>
			        <span style="margin-right:10px"> {name}，人数：{num}，占比：{ratio}</span>
			        </div>
			        `,
				});
				this.chart16.interval().position("name*num").tooltip("name*num*ratio", function(name, num, ratio) {
					return {
						name,
						num,
						ratio
					};
				});
				this.chart16.render();
			},
			//视频观看设备
			drawChart17() {
				if (this.chart17) this.chart17.destroy();

				let _data = [];
				_data = [...this.chartdata.videoDeviceDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart17 = new Chart({
					container: 'videodevicesChart',
					autoFit: true,
					height: 400,
				});
				this.chart17.coordinate('theta', {
					radius: 0.6,
				});

				this.chart17.data(_data);
				this.chart17.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart17.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart17.legend('name', {
					position: 'top',
				});
				this.chart17
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								//return obj.name + '：（人数：' + obj.num + ' 占比：' + obj.ratio + '）';
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart17.render();
			},
			//单次播放视频时长分布
			drawChart18() {
				if (this.chart18) this.chart18.destroy();

				let _data = [];
				_data = [...this.chartdata.durationDiagrams];
				_data.map(v => {
					v.percent = v.num
				})
				_data = _data.filter(v => v.num > 0);


				this.chart18 = new Chart({
					container: 'videotimeChart',
					autoFit: true,
					height: 400,
				});
				this.chart18.coordinate('theta', {
					radius: 0.6,
				});

				this.chart18.data(_data);
				this.chart18.scale('percent', {
					formatter: (val) => {
						val = (val * 100).toFixed(2) + '%';
						return val;
					},
				});

				this.chart18.tooltip({
					showTitle: false,
					showMarkers: false,
				});

				this.chart18.legend('name', {
					position: 'top',
				});
				this.chart18
					.interval()
					.adjust('stack')
					.position('percent')
					.color('name')
					.label('percent', (val) => {
						return {
							// offset: val > 0.05 ? -30 : null,
							content: (obj) => {
								return obj.name + '-' + obj.num + '-' + obj.ratio;
							},
						};
					})
					.tooltip('name*num*ratio', (name, num, ratio) => {

						return {
							name: name,
							num: num,
							value: num,
						};
					});
				this.chart18.render();
			},
			// 导出
			export () {
				this.notify = this.$notify.info({
					title: '提示',
					message: '正在为您创建导出任务，请耐心等待',
					offset: 100,
					duration: 0
				});
				this.$request({
						url: "/label/export",
						method: "POST",
						data: {
							...this.queryData
						},
					})
					.then((res) => {
						const {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
								confirmButtonText: '立即查看',
								cancelButtonText: '稍后再看',
								type: 'success',
								center: true,
								closeOnClickModal: false
							}).then(() => {
								this.$router.push({
									path: '/workbench/downloadList'
								})
							}).catch(() => {})
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.notify.close();
					});
			},
			changeType() {
				this.formData.queryActivityType = ['0']
				this.formData.queryValue = ''
				this.formData.sellArea = []
			},
			//重置
			reset() {
				this.formData.queryList = [{
					..._defaultQueryGroup,
					query: [{
						..._defaultQuery
					}]
				}]

				this.formData.queryType = 1
				this.formData.queryValue = ''
				this.formData.sellArea = []
				this.formData.diagrams = ['0', '1', '2', '3', '4', '6', '15'],
					this.formData.queryActivityType = ['0']
				this.chartdata = {}
				this.mapData = []
				const date = new Date();
				const month = date.getMonth();
				const day = date.getDate();
				const start = new Date();
				const end = new Date();
				start.setMonth(month - 3, day);
				start.setHours(0, 0, 0);
				end.setHours(23, 59, 59);
				this.datetimerange = [dayjs(start).format('YYYY-MM-DD HH:mm:ss'), dayjs(end).format('YYYY-MM-DD HH:mm:ss')]
				this.eventsActivityDiagrams = []
			},
			//清除
			clearQuery() {
				this.$confirm('是否重置所有查询条件？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					// type: 'warning',
					center: true,
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.reset();
				}).catch(() => {});
			}
		}

	}
</script>

<style lang="scss" scoped>
	.current {
		color: #fff;
		background-color: #1fbb7d;
		border-color: #1fbb7d;
	}

	.map {
		height: 410px;
		position: relative;
		width: 60%;

		.img {
			position: absolute;
			right: 20px;
			top: 15px;
		}
	}

	.query-group {
		display: flex;

		.params-group {
			display: flex;
			flex: 1;
			position: relative;

			&::after {
				content: "";
				position: absolute;
				top: 18px;
				left: -19px;
				width: 20px;
				height: 1px;
				background: #e6e6e6;
			}

			.el-form-item {

				&:first-child,
				&:last-child {
					flex: 1;
				}

				&:nth-child(2) {
					width: 125px;
					margin: 0 10px;
				}
			}
		}

		.handle {
			margin-left: 20px;
			width: 70px;
		}
	}


	.add-query-btn {
		width: 100%;
		// border-style: dashed;
	}

	.query-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	table {
		// border-top: 1px #eee solid;
		// border-bottom: 1px #eee solid;

		td {
			padding-top: 22px;

			&.isOr {
				width: 140px;
				border-right: 1px #eee solid;

				.el-form-item {
					position: relative;

					&::after {
						content: "";
						position: absolute;
						top: 18px;
						right: -1px;
						width: 16px;
						height: 1px;
						background: #e6e6e6;
					}
				}
			}

			&.params {
				padding-left: 20px;
			}
		}
	}

	// .cardBox {
	// 	display: flex;
	// 	justify-content: space-between;
	// 	flex-wrap: wrap;

	// }

	.cardBox .box-card {
		height: 500px;
	}

	.chinamap {
		width: 100%;
		height: 600px;
		text-align: center;
		margin-top: 20px
	}


	.diagrams-group {
		.diagrams-title {
			font-size: 13px;
			font-weight: 700;
		}
	}
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 18px;
            margin-bottom: 5px;
			font-weight: bold;
        }
    }
}
</style>
